import React from 'react';

export default function Page({ children }) {
  return (
    <section className='page'>
      {children}
    </section>
  );
}
